import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { isMock } from "./config";
import { takeHandedOffSession, viewAsFromLocation } from "./viewAs";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

async function start() {
  if (isMock) {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass", quiet: true });
  }
  // ADR-0011: a view-as tab inherits the staff member's session from the tab that opened it.
  takeHandedOffSession();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter basename={viewAsFromLocation()?.basename}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}

void start();
